import { render, staticRenderFns } from "./plan_cut_chart.vue?vue&type=template&id=0f4838f7&"
import script from "./plan_cut_chart.vue?vue&type=script&lang=js&"
export * from "./plan_cut_chart.vue?vue&type=script&lang=js&"
import style0 from "./plan_cut_chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QSpace,QBtn,QSelect,QInput,QIcon,QPopupProxy,QDate,QTooltip,QMarkupTable,QCard,QCardSection,QBtnToggle,QBtnGroup,QTable,QTd,QInnerLoading,QSpinnerGears,QDialog,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QSpace,QBtn,QSelect,QInput,QIcon,QPopupProxy,QDate,QTooltip,QMarkupTable,QCard,QCardSection,QBtnToggle,QBtnGroup,QTable,QTd,QInnerLoading,QSpinnerGears,QDialog,QSeparator,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
